
import { HttpSystemPortList,HttpDeleteSystemPort} from '@/service/basicdata';
import TableList from "@components/templates/tablelist";

import comIndex from './update'
import { mapGetters } from 'vuex';

export default {
    mixins: [TableList],
    components:{
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            addressCodeList:[],
            formData: {
                search: {
                },
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            title:"",
            entitle:"",
            Plugins: { show: true },
        };
    },
    created() {
      },
    methods: {
        ajaxRequest: HttpSystemPortList,
       
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show:true,
                        width:500,
                        component: "comIndex",
                        type:'add',
                        showFooter:false,
                    }
                    break;    
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show:true,
                        width:500,
                        component: "comIndex",
                        activeid:params,
                        type:'query',
                        showFooter:false,
                    }
                    break;          
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show:true,
                        width:500,
                        component: "comIndex",
                        activeid:params,
                        type:'edit',
                        showFooter:false,
                    }
                    break;
                case "delete":
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { id: params },
                        title: this.$t('global.common.delete', { defaultValue: '删除' }),
                        ajaxRequest: HttpDeleteSystemPort,
                        desc: this.$t('fbb.localemanage.confirm_delete', { defaultValue: '删除后不可恢复，是否确认删除？' }),
                    }
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show:true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show:true,
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('global.common.delete', { defaultValue: '删除' }),
                params: id,
                operate: 'delete',
                show: true
            }
          ]
        },
        
    },
    computed: {
        ...mapGetters('dictionary', ['getSystemPortList']),
        ToolsData() {
            return [{
                name: this.$t('global.common.add', { defaultValue: "添加" }),
                operate: "add",
                theme: "primary",
            }]
        },
        SearchsData() {
            return [{
                    label: this.$t('fbb.basic.port_name', { defaultValue: '港口名称' }),
                    key: 'EQ_title',
                    tag: 'vInput',
                    show: true,
                },{
                    label: this.$t('fbb.basic.port_code', { defaultValue: '港口Code' }),
                    key: 'EQ_code',
                    tag: 'vInput',
                    show: true,
                }
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    width: 90,
                    render: this.getOperateNodes
                },{
                    title: this.$t('fbb.basic.port_name', { defaultValue: '港口名称' }),
                    key: 'title',
                }, {
                    title: this.$t('fbb.basic.port_code', { defaultValue: '港口Code' }),
                    key: 'code',
                }, {
                    title: this.$t('fbb.accountmanage.description', { defaultValue: '描述' }),
                    key: 'description',
                }];
        },
    },
};




